import { VerticalContainer } from '@/components';
import { cn } from '@/lib/cn';

import { PropertyObjectType } from '../model/types';
import { Property } from './Property';

type PropertiesListProps = {
    properties: PropertyObjectType[];
    className?: string;
};

export const PropertiesList = ({
    properties,
    className,
}: PropertiesListProps) => {
    return (
        <VerticalContainer className={cn('w-full', className)} spacing="sm">
            {properties.map((property) => (
                <Property
                    key={property.type + property.label}
                    {...property}
                    className="items-center"
                />
            ))}
        </VerticalContainer>
    );
};
